import { LoyaltyProvider } from 'util/client-configuration';
import { ClientConfiguration } from '../client-domain.types';

export const clientConfig: ClientConfiguration = {
  dateCreated: 1643382484.857,
  dateUpdated: 1645033366.129,
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  guestCheckOutEnabled: true,
  guestCheckoutVerification: { enabled: true, deliveryMethod: 'EMAIL' },
  guestJourney: { enabled: true, enabledMenuIntelligence: true },
  sms: {
    enabledMarketing: true,
    enabledOrdering: false,
    enabledAccountVerification: true,
    enabled: true,
    twilioMessageServiceSid: '',
    twilioPassword: '',
    twilioPhoneNumber: '',
    twilioUsername: '',
  },
  workspaces: { enabled: false },
  scanToPay: {
    enabled: true,
    tippingEnabled: false,
    tipValues: ['5', '10', '20'],
    defaultTip: '10',
    tipHeader: {
      EN: 'Tip The Restaurant Crew',
      FR: 'Tip The Restaurant Crew French',
      ES: 'Tip The Restaurant Crew spanish',
    },
  },
  programsAndCampaigns: { enabled: false },
  giftCard: {
    addGiftCardToWallet: true,
    cardDetails: null,
    defaultLocation: null,
    defaultMerchant: null,
    giftCardHeader: null,
    giftCardLookUp: true,
    giftCardTitle: null,
    hideQrCode: null,
    isActive: true,
    maxAmount: null,
    minAmount: null,
    purchaseNewGiftCard: true,
    purchaseWithGiftCard: true,
    reloadGiftCard: true,
    securityCodeEnabled: false,
    selectableAmount: null,
    sendByEmailIsActive: true,
    walletOrder: null,
  },
  recaptcha: true,
  incentivioPayments: {
    enabled: true,
    paymentFee: 100,
    processingRate: '2.9',
  },
  socialSignIn: {
    enabled: false,
    appleClientId: '',
    googleClientId: '',
    googleClientSecret: '',
  },
  emailSetting: {
    dynamicEmailTemplateEnabled: false,
    emailHandler: 'SENDGRID',
  },
  loyaltyNumberStrategy: {
    strategy: 'INCENTIVIO_STRATEGY',
    accountNoPrefix: 'PLD',
    accountNoPostfixStartFrom: 1,
    accountNoPostfixDigitCount: 6,
  },
  silverwareExtLoyaltyIdStrategy: {
    appVersion: 'v57',
    loyaltyApiMerchantId: '988503',
    loyaltyApiMerchantCred: 'M988503:A4XmfqTL24u5',
    orderSubmissionCredential: 'ApiKey:00000000-0000-1000-8000-000000000000',
    clientPrefix: 'STLO',
    cardTypePrefix: '11',
  },
  userAccountVerification: { method: 'EMAIL_LINK' },
  loyaltyProvider: {
    type: LoyaltyProvider.INCENTIVIO,
    enabled: true,
  },
  toastApplePay: null,
  viewOnlyLocationEnabled: false,
  downloadCustomerListEnabled: false,
  enableFulFillText: true,
  upsellRecommendation: {
    enabled: true,
  },
  passwordlessAuthentication: {
    enabled: true,
    deliveryMethod: ['EMAIL'],
    magicLinkSettings: {
      android: {
        packageName: 'com.ce.android.brand.pureburger',
        fingerPrint1:
          '2A:32:BD:50:49:B0:C8:37:6C:F5:14:2D:17:BC:55:14:37:B5:E1:36:FE:8A:F2:6F:6C:0C:09:5A:C1:61:84:89',
        fingerPrint2:
          'E1:17:D3:8E:8A:0D:64:6D:B2:70:DA:27:58:66:4D:81:D8:EE:60:98:73:08:D6:DB:DE:65:31:E6:72:71:A6:58',
        fingerPrint3:
          'DD:8A:7A:63:D5:2A:04:4E:3E:8F:30:CA:A6:A5:D8:74:9A:9B:DB:7F:60:2B:BC:DF:80:3E:06:A3:CD:BC:EC:1D',
        assetLinksFileUrl:
          'https://palmlanedev.magiclink.incentiviodev.com/.well-known/assetlinks.json',
      },
      ios: {
        teamId: 'Y7KL3924FZ',
        bundleId: 'com.incentivio.pureBurger',
        appleAppSiteAssociationFileUrl:
          'https://palmlanedev.magiclink.incentiviodev.com/.well-known/apple-app-site-association',
      },
    },
  },
};

export const clientConfigEmailSetting = {
  sendGrid: {
    enabled: true,
    activeDomainId: '1',
    fromEmail: 'test.t',
    fromName: 'Test Incentivio From',
    replyToEmail: 'test.t',
    replyToName: 'Test Incentivio Reply',
  },
};
